import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider, DefaultTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import type { RootState } from '../../redux/store';
import type { ErrorStateProps } from './types';
import {
  DEFAULT_MESSAGE,
  DEFAULT_RETRY_TEXT,
  DEFAULT_SHOW_ICON,
  ERROR_ICON_SIZE,
} from './constants';
import {
  ErrorContainer,
  IconWrapper,
  ErrorTitle,
  ErrorMessage,
  RetryButton,
} from './styles';

const ErrorState: React.FC<ErrorStateProps> = ({
  message = DEFAULT_MESSAGE,
  retryText = DEFAULT_RETRY_TEXT,
  onRetry,
  icon,
  className,
  title,
  showIcon = DEFAULT_SHOW_ICON,
}) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme);

  const theme: DefaultTheme = {
    mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark',
  };

  const displayTitle = title || message;
  const displayMessage = title ? message : undefined;

  return (
    <ThemeProvider theme={theme}>
      <ErrorContainer className={className}>
        {showIcon && (
          <IconWrapper>
            {icon || <FontAwesomeIcon icon={faExclamationCircle} size={ERROR_ICON_SIZE} />}
          </IconWrapper>
        )}
        <ErrorTitle level={4}>{displayTitle}</ErrorTitle>
        {displayMessage && <ErrorMessage>{displayMessage}</ErrorMessage>}
        {onRetry && (
          <RetryButton type="primary" onClick={onRetry}>
            {retryText}
          </RetryButton>
        )}
      </ErrorContainer>
    </ThemeProvider>
  );
};

export default React.memo(ErrorState);
